import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useBannerInView } from '@client/hooks/useBannerInView'
import { useBannerViewAnalytics } from '@client/hooks/useBannerViewAnalytics'
import { getIsMobile } from '@client/selectors/appSelectors'
import { PopupBannerItem } from '@client/types'
import { makeClassName } from '@client/utils/makeClassName'
import { sendBannerClickAnalytics } from '@client/utils/sendBannerClickAnalytics'

import { PopoverDismissIcon } from './PopoverDismissIcon'

import styles from './PopoverBannerContent.module.css'

export const PopoverBannerContent = ({
  content,
  handleDismiss,
  handleClose
}: {
  content: PopupBannerItem
  handleDismiss: () => void
  handleClose: () => void
}) => {
  const {
    alt,
    buttonText,
    buttonUrl,
    text,
    primaryColor,
    border,
    backgroundGradient,
    secondaryColor,
    buttonTextColor
  } = content

  const isMobile = useSelector(getIsMobile)
  const dispatch = useDispatch()

  const position = 'popup'

  const handleButtonClick = () => {
    handleDismiss()
    sendBannerClickAnalytics(content, position, dispatch)
  }

  const { ref, inView } = useBannerInView()

  useBannerViewAnalytics({
    inView,
    banner: content,
    position,
    dispatch
  })

  const variables = {
    '--background': backgroundGradient,
    '--primary': primaryColor,
    '--secondary': secondaryColor,
    '--button-text': buttonTextColor
  } as React.CSSProperties

  return (
    <div
      className={makeClassName([
        [styles.root, true],
        [styles.withBorder, border]
      ])}
      ref={ref}
      style={variables}
    >
      <button className={styles.dismiss} onClick={handleClose} type="button">
        <PopoverDismissIcon isMobile={isMobile} />
      </button>

      <div className={styles.content}>
        <h3
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: alt }}
        />
        <p className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
      </div>

      <div className={styles.buttonContainer}>
        <a
          href={buttonUrl}
          className={styles.button}
          onClick={handleButtonClick}
        >
          {buttonText}
        </a>
      </div>
    </div>
  )
}
